import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APIRequestResources, CachedAPIRequest } from 'src/app/core';
import { DepartmentDTO, ManualOperationUnapprovalDTO, OperatorSummaryItemDTO, ShiftOeprations } from '../interfaces/operation-shift.entity';
import { MachineMonthlyOutputDTO } from '../interfaces/operator-output.entity';

@Injectable({
  providedIn: 'root'
})
export class OperationShiftService extends CachedAPIRequest {

  constructor(protected override http: HttpClient, private router: Router) {
      super(http, APIRequestResources.OperationShiftService)
    }

  getShiftOutputByDep(searchParams:any, refresh = true) {
      return this.get<DepartmentDTO>({endpoint: `get_by_department`, params: searchParams }, refresh ? 'freshness' : 'performance')
          .pipe();
    }

   getShiftOutputByMachine(searchParams:any, refresh = true) {
      return this.get<MachineMonthlyOutputDTO>({endpoint: `get_by_machine`, params: searchParams }, refresh ? 'freshness' : 'performance')
          .pipe();
    }

  getShiftOperationsByDep(searchParams:any, refresh = true) {
      return this.get<ShiftOeprations>({endpoint: `get_operations_by_department`, params: searchParams }, refresh ? 'freshness' : 'performance')
          .pipe();
    }
 
  getOperatorSummaryByJobOperation(id: number, refresh = true) {
    return this.get<OperatorSummaryItemDTO[]>({
      endpoint: `operator_summary_by_job_operation/${id}` }, refresh ? 'freshness' : 'performance').pipe();
  }

  getPreviousShiftOutput(params: { year: number; month: number; day: number; shift: number; machine: number }, refresh = true) {
    return this.get<any>({ endpoint: `previous_shift_output`, params }, refresh ? 'freshness' : 'performance').pipe();
  }

  getShiftMonthlyOutputByMachine(params: { year: number; month: number; machine: number }, refresh = true) {
    return this.get<any[]>({ endpoint: `get_shift_output_by_machine`, params }, refresh ? 'freshness' : 'performance').pipe();
  }
  
  getUnapprovedOutputs(params: { approvalStatus?: 'PENDING' | 'APPROVED' | 'REJECTED'; startDate?: string; endDate?: string; operator?: number | string; shift?: number | string }, refresh = true) {
    return this.get<ManualOperationUnapprovalDTO[]>({ endpoint: `get_unapproved_outputs`, params }, refresh ? 'freshness' : 'performance').pipe();
  }

  approveManualOutput(id: number, status: 'APPROVED' | 'REJECTED') {
    return this.patch<any>({ status }, { endpoint: `approve/outputs/${id}` }).pipe();
  }

}